'use client';
import React from 'react';
import { FC, ReactElement } from 'react';

const ColCentered:FC<{children: ReactElement}> = ({children}) => {
    return <div className='min-h-48 py-24'>
        <div className="container flex flex-col items-stretch justify-center lg:flex-row gap-40">
            <div className="lg:w-3/5">{children}</div>
        </div>
    </div>
}

export default ColCentered